import get from 'lodash/get';
import { actions } from 'app-webtech-core/actions';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { prepareEndpointWithState } from 'app-webtech-core/store/plutoApiInjectorMiddleware';
import { bootstrapLoaded } from 'app-webtech-core/modules/application/actions';
import bootstrapURL from 'app-modules/application/utils/bootstrapURLFromStorage';

import url from 'url';

import { SETUP, BOOTSTRAP_REQUEST, SET_SESSION_TOKEN } from './types';
import { PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY } from '../../player/constants';

const applicationSetupAction = actionCreator(SETUP);
const bootstrapRequestAction = actionCreator(BOOTSTRAP_REQUEST);
const setSessionTokenAction = actionCreator(SET_SESSION_TOKEN);

async function getBootstrapData(getState) {
  const state = getState();
  const endpoint = prepareEndpointWithState(
    `${bootstrapURL().getBootstrapURL() || process.env.BOOTSTRAP_BASE_URL}/${process.env.BOOTSTRAP_VERSION || 'v1'}/start`,
    state,
    true,
  );
  const appName = state.desktop && state.desktop.enabled ? 'desktop' : 'web';
  const deviceType = state.embed.enabled ? 'embed' : 'web';
  const lastChannelID = global.window && global.window.localStorage.getItem(PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY);
  const initialContent = {
    channelSlug: get(state, 'location.payload.slug'),
    episodeSlugs: get(state, 'location.payload.movieSlug'),
  };
  if (!initialContent.channelSlug && !initialContent.episodeSlugs) {
    initialContent.channelID = lastChannelID;
  }
  // Re-parsing the endpoint url to include missing parameters that bootstrap require
  const parsedEndpoint = url.parse(endpoint, true);
  parsedEndpoint.query = {
    ...parsedEndpoint.query,
    ...initialContent,
    appName,
    deviceType,
    appVersion: process.env.APP_VERSION,
    clientID: parsedEndpoint.query.deviceId,
    clientModelNumber: 'na',
  };
  parsedEndpoint.search = undefined;
  const bootstrapUrl = url.format(parsedEndpoint);

  const response = await fetch(bootstrapUrl);
  return response.json();
}

export const applicationSetupActionThunkAction = (payload) => async (dispatch, getState) => {
  let myIpv1;
  let myIpv4;
  let userCountryCodev1;
  let userCountryCodev4;
  let stitcherParams;
  let servers;
  let sessionToken;
  let sessionID;
  let startingChannel;
  let enableVOD = true;
  let restartThresholdMS;
  let marketingRegion;
  let ratings;
  let ratingDescriptors;
  let includeGooglePalNonce;
  const isGooglePalEnabled = process.env.ENABLE_GOOGLE_PAL === 'true' || false;
  try {
    ({
      countryCode: userCountryCodev1,
      ip: myIpv1,
      features: { 
        vodShow: enableVOD,
        googlePalNonce: includeGooglePalNonce = isGooglePalEnabled,
      },
      servers,
      sessionToken,
      session: {
        sessionID,
        clientIP: myIpv4,
        activeRegion: userCountryCodev4,
        marketingRegion,
        restartThresholdMS,
      },
      servers,
      startingChannel,
      stitcherParams,
      ratings,
      ratingDescriptors,
    } = await getBootstrapData(getState));
    await dispatch(
      setSessionTokenAction({
        sessionToken,
      }),
    );
    await dispatch(
      actions.playbackSession.setMarketingRegion({
        marketingRegion: marketingRegion.toLowerCase(),
      }),
    );
    await dispatch(actions.playbackSession.setID({ ID: sessionID }));
    await dispatch(bootstrapRequestAction(payload));
    await dispatch(
      actions.ratings.setRatings({
        ratings,
      }),
    );
    await dispatch(
      actions.ratingsDescriptors.setRatingsDescriptors({
        ratingDescriptors,
      }),
    );
  } catch (e) {
    stitcherParams = false;
    servers = {};
  }
  dispatch(bootstrapLoaded());

  await dispatch(
    applicationSetupAction({
      ...payload,
      myIp: myIpv1 || myIpv4 || 'na',
      userCountryCode: (userCountryCodev1 || userCountryCodev4 || 'na').toLowerCase(),
      enableVOD,
      includeGooglePalNonce,
      restartThresholdMS,
      servers,
      stitcherParams: stitcherParams
        ? stitcherParams
          .split('&')
          .map((query) => query.split('='))
          .reduce((acc, [parameter, value]) => ({ ...acc, [parameter]: value }), {})
        : {},
    }),
  );

  if (startingChannel && getState().location.type.includes('WATCH')) {
    await dispatch(
      actions.player.load({
        kind: 'linearChannel',
        slug: startingChannel.slug,
        id: `${startingChannel.id}`,
      }),
    );
    if (global.window) {
      global.window.localStorage.setItem(PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY, startingChannel.id);
    }
  }
};
